import { HeaderCategory, HeaderPeriod, HeaderTotal } from "./DRE.styles"

/* eslint-disable */
const DREHeader = ({ periods }) => (
  <div style={{ display: 'flex', width: '100%' }}>

    <HeaderCategory>
      CATEGORIA
    </HeaderCategory>

    {periods.map((period) => (
      <HeaderPeriod key={period}>
        {period}
      </HeaderPeriod>
    ))}

    <HeaderTotal>
      Total
    </HeaderTotal>

  </div>
)

export default DREHeader